export enum AdminProductListItemAction {
  Edit,
  Preview,
  Remove,
}
